import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServiceFunctionLastEditorsGet = {
    path: "/template/service/functions/last-editors",
    method: ERouteHttpVerb.GET
};
export { routeLocationServiceFunctionLastEditorsGet };
